/**
 * @module FE_CU40_メインユーザー移譲画面
 */
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import PcPageTitle from '@/components/pcPageTitle/PcPageTitle.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU40';

export default {
  name: 'MainUserTransfer',
  components: {
    Header,
    BreadCrumbList,
    PcPageTitle,
    ListPanel,
    MobileFooter,
    PCFooter,
  },
  props: [window.origin],
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU40メインユーザー移譲画面.メインユーザー移譲'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU40メインユーザー移譲画面.C0001'),
      radioGroup: null,
      panelResult: [],
      userResult: [],
      // Dialog
      dialogs: {
        confirm: false,
        password: false,
      },
      password: '',
      showPassword: false,
      rules: {
        password: {
          require: (value) =>
            !!value ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU40メインユーザー移譲画面.E0001'),
        },
      },
      displayAreaTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      contract: {
        usagePlan: '',
        customerNumber: '',
        securityDestinationName: '',
      },
      originUser: { userId: '', name: '', userType: 1 },
      destination: {
        userId: '',
        name: '',
        userType: 2,
      },
      loading: false,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU40メインユーザー移譲画面.メインユーザー移譲'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU40メインユーザー移譲画面.C0001'),
        displayAreaTitle: {
          place: '',
          type: '',
          typeIsBefore: true,
        },
      };
    },
    validatePassword() {
      return !this.password || this.loading;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (!this.$route.params.origin) {
      this.originUser = this.$store.state.origin;
    } else {
      this.originUser = this.$route.params.origin;
    }

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //ローディングマーク表示と合わせて色々再見直ししたほうが良いかも
    this.isShowPage = true;

    let param =
      this.$store.state.currentDisplayType === 1
        ? '/api/mainUserTransfer/initDisplayDistrict'
        : '/api/mainUserTransfer/initCamera';

    let method = 'post';
    // 1:対象地区 2:カメラ
    if (this.$store.state.currentDisplayType == 1) {
      // 対象地区の場合
      const queries = {
        token: sessionStorage.getItem('token'), // JWTトークン sessionStorageから取得する
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber, //お客様番号
        districtSplitNumber: this.$store.state.districtSplitNumber, // 地区番号
      };
      await this.APP_CU4001(param, queries, method);
    } else if (this.$store.state.currentDisplayType == 2) {
      // カメラの場合
      const queries = {
        token: sessionStorage.getItem('token'), // JWTトークン sessionStorageから取得する
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID, //デバイスID
      };
      await this.APP_CU4003(param, queries, method);
    }
  },
  /** @type {Methods} */
  methods: {
    /**
     * ラジオボタン切り替え時処理
     * @param {Number} id ユーザー情報一覧インデックス
     */
    toggleRadioButton(id) {
      this.destination = this.userResult[id];
    },
    /**
     * 移譲ボタン活性制御処理
     * @returns 移譲ボタンが非活性かどうか
     */
    canTransfer() {
      return this.radioGroup == null;
    },
    /**
     * 初期表示（表示地区）API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    APP_CU4001: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      let hasError = false;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ(対象地区)
            // apiData = {
            //   contentsInfo: {
            //     // 対象地区情報
            //     displayDistrictInfo: {
            //       usagePlan: 1, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-12345678", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区名1234", // 地区名
            //       displayDistrictNickname: "ニックネーム1", // ニックネーム(対象地区)
            //     },
            //     // ユーザー情報一覧
            //     userInfoList: [
            //       {
            //         userId: "123456789",
            //         name: "警備 太郎",
            //         displayDistrictUserType: 2, // 1：メイン 2：サブ
            //       },
            //       {
            //         userId: "123456788",
            //         name: "警備 次郎",
            //         displayDistrictUserType: 2,
            //       },
            //     ],
            //   },
            // };
          },
          (error) => {
            hasError = true;
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
              return;
            } else {
              this.$_abnormality(error.response.status);
              return;
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      if (hasError) return;

      const targetItem = apiData.contentsInfo.displayDistrictInfo;

      // ------- データ整形 -------
      const labels = {
        usagePlan: '$vuetify.FECU40メインユーザー移譲画面.対象地区詳細表示領域.利用プラン',
        customerNumber: '$vuetify.FECU40メインユーザー移譲画面.対象地区詳細表示領域.お客様番号',
        securityDestinationName:
          '$vuetify.FECU40メインユーザー移譲画面.対象地区詳細表示領域.警備先名',
        districtSplitNumber: '$vuetify.FECU40メインユーザー移譲画面.対象地区詳細表示領域.地区番号',
        districtSplitName: '$vuetify.FECU40メインユーザー移譲画面.対象地区詳細表示領域.地区名',
      };
      const targetKeys = ['usagePlan', 'customerNumber', 'securityDestinationName'];
      const planTitles = {
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
      };

      // ListPanelコンポーネント用に整形
      Object.keys(targetItem).map((key) => {
        if (targetKeys.includes(key)) {
          let text = targetItem[key];
          if (key === 'usagePlan') {
            text = planTitles[targetItem[key]];
            this.contract.usagePlan = planTitles[targetItem[key]];
          }
          if (key === 'districtSplitNumber') {
            if (targetItem[key] === '    ') {
              text = '$vuetify.FECU40メインユーザー移譲画面.メイン地区';
            }
            if (targetItem[key] === '') {
              return;
            }
          }
          this.panelResult = [
            ...this.panelResult,
            {
              title: labels[key],
              text: text,
              // isVuetifyKey: text.includes("$"),
            },
          ];
        }
      });

      this.contract.customerNumber = apiData.contentsInfo.displayDistrictInfo.customerNumber;
      this.contract.securityDestinationName =
        apiData.contentsInfo.displayDistrictInfo.securityDestinationName;

      // ユーザー表示用にデータを設定
      this.displayAreaTitle = {
        place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
        type: '$vuetify.FECU40メインユーザー移譲画面.対象地区詳細表示領域.対象地区',
        typeIsBefore: true,
      };
      // サブユーザーのみ表示
      this.userResult = apiData.contentsInfo.userInfoList.filter((user) => {
        if (user.displayDistrictUserType == 2) {
          return user;
        }
      });

      return apiData;
    },
    /**
     * 初期表示（カメラ）API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    APP_CU4003: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      let hasError = false;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ(カメラ)
            // apiData = {
            //   contentsInfo: {
            //     // カメラ情報
            //     cameraInfo: {
            //       usagePlan: 0, // 0: オンライン監視プラン 1: 依頼かけつけプラン 2:セルフ監視プラン
            //       customerNumber: "51-12345678", // お客様番号
            //       securityDestinationName: "警備先1", // 警備先名
            //       districtSplitNumber: "0001", // 地区番号
            //       districtSplitName: "地区名1234", // 地区名
            //       displayDistrictNickname: "ニックネーム1", // ニックネーム(対象地区)
            //       cameraNickname: "カメラニックネーム1", // ニックネーム(カメラ)
            //       deviceID: "1234",
            //     },
            //     // ユーザー情報一覧
            //     userInfoList: [
            //       {
            //         userId: "123456789@mail.com",
            //         name: "警備 太郎",
            //         cameraUserType: 1, // 1：メイン 2：サブ
            //       },
            //       {
            //         userId: "123456788@mail.com",
            //         name: "警備 次郎",
            //         cameraUserType: 2,
            //       },
            //     ],
            //   },
            // };
          },
          (error) => {
            hasError = true;
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
              return;
            } else {
              this.$_abnormality(error.response.status);
              return;
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      if (hasError) return;

      const targetItem = apiData.contentsInfo.cameraInfo;

      // ------- データ整形 ---------
      const labels = {
        usagePlan: '$vuetify.FECU40メインユーザー移譲画面.カメラ詳細表示領域.利用プラン',
        customerNumber: '$vuetify.FECU40メインユーザー移譲画面.カメラ詳細表示領域.お客様番号',
        securityDestinationName:
          '$vuetify.FECU40メインユーザー移譲画面.カメラ詳細表示領域.警備先名',
        districtSplitNumber: '$vuetify.FECU40メインユーザー移譲画面.カメラ詳細表示領域.地区番号',
        districtSplitName: '$vuetify.FECU40メインユーザー移譲画面.カメラ詳細表示領域.地区名',
        displayDistrictNickname:
          '$vuetify.FECU40メインユーザー移譲画面.カメラ詳細表示領域.ニックネーム対象地区',
        deviceID: '$vuetify.FECU40メインユーザー移譲画面.カメラ詳細表示領域.デバイスID', //"デバイスID",
      };
      const targetKeys = [
        'usagePlan',
        'customerNumber',
        'securityDestinationName',
        'districtSplitNumber',
        'districtSplitName',
        'displayDistrictNickname',
        'deviceID',
      ];
      const planTitles = {
        [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
        [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
      };
      // ListPanelコンポーネント用に整形
      Object.keys(targetItem).map((key) => {
        if (targetKeys.includes(key)) {
          let text = targetItem[key];
          if (key === 'usagePlan') {
            text = planTitles[targetItem[key]];
            this.contract.usagePlan = planTitles[targetItem[key]];
          }
          if (key === 'districtSplitNumber') {
            if (targetItem[key] === '    ') {
              text = '$vuetify.FECU40メインユーザー移譲画面.メイン地区';
            }
            if (targetItem[key] === '') {
              return;
            }
          }
          this.panelResult = [
            ...this.panelResult,
            {
              title: labels[key],
              text: text,
              // isVuetifyKey: text.includes("$"),
            },
          ];
        }
      });

      this.contract = {
        ...this.contract,
        customerNumber: apiData.contentsInfo.cameraInfo.customerNumber,
        securityDestinationName: apiData.contentsInfo.cameraInfo.securityDestinationName,
      };

      // ユーザー表示用にデータを設定
      this.displayAreaTitle = {
        place: `- ${apiData.contentsInfo.cameraInfo.cameraNickName}`,
        type: '$vuetify.FECU40メインユーザー移譲画面.カメラ詳細表示領域.カメラ',
        typeIsBefore: true,
      };
      //  `カメラ - ${apiData?.contentsInfo?.cameraInfo?.displayDistrictNickname}`;
      // サブユーザーのみ表示
      this.userResult = apiData.contentsInfo.userInfoList.filter((user) => {
        if (user.cameraUserType === 2) {
          return user;
        }
      });

      return apiData;
    },
    /**
     * メインユーザー移譲（表示地区）API実行処理
     * @returns apiData レスポンス
     */
    APP_CU4002: async function () {
      let param = '/api/mainUserTransfer/transferDisplayDistrict';
      // let param = "post";

      let method = 'post';
      const queries = {
        token: sessionStorage.getItem('token'), // JWTトークン sessionStorageから取得
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber, //お客様番号
        districtSplitNumber: this.$store.state.districtSplitNumber, // 地区番号
        password: this.password, // 入力されたパスワード
        subUserId: this.userResult[this.radioGroup].userId, // 選択しているサブユーザーID
      };
      let apiResult = false;
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            // apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            this.dialogs['password'] = false;
            await this.$informationDialog(
              '$vuetify.メッセージ一覧.FECU40メインユーザー移譲画面.C0004'
            );

            this.goThanksPage();
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU40メインユーザー移譲画面.E0006');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        );

      return apiResult;
    },
    /**
     * メインユーザー移譲（カメラ）API実行処理
     * @returns apiData レスポンス
     */
    APP_CU4004: async function () {
      let param = '/api/mainUserTransfer/transferCamera';
      // let param = "post";

      let method = 'post';
      // リクエスト
      const queries = {
        token: sessionStorage.getItem('token'), // JWTトークン sessionStorageから取得する
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID, //デバイスID
        password: this.password, // 入力されたパスワード
        subUserId: this.userResult[this.radioGroup].userId, // 選択しているサブユーザーID
      };

      let apiResult = false;

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            // apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            this.dialogs['password'] = false;
            await this.$informationDialog(
              '$vuetify.メッセージ一覧.FECU40メインユーザー移譲画面.C0004'
            );

            this.goThanksPage();
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU40メインユーザー移譲画面.E0006');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        );

      return apiResult;
    },
    /**
     * ダイアログ呼び出し処理
     * @param {String} type ダイアログタイプ
     */
    toggleDialog(type) {
      switch (type) {
        case 'confirm':
          this.dialogs['confirm'] = !this.dialogs['confirm'];
          break;
        case 'password':
          this.dialogs['confirm'] = false;
          this.dialogs['password'] = !this.dialogs['password'];
          break;
        case 'passwordCancel':
          this.dialogs['confirm'] = false;
          this.dialogs['password'] = !this.dialogs['password'];
          this.password = '';
          this.$refs.passwordForm.reset();
          break;
        case 'error':
          this.dialogs['error'] = !this.dialogs['error'];
          break;
        default:
          break;
      }
    },
    /**
     * Thanks画面遷移処理
     */
    goThanksPage() {
      this.$store.commit('setThanksType', {
        fromPageInfo: { page: 40 },
        displayType: 1,
      });
      this.$router.replace({
        path: '/thanks',
      });
    },
    /**
     * メインユーザー移譲処理
     */
    async verifyPassword() {
      this.loading = true;
      // 1:対象地区 2:カメラ
      if (this.$store.state.currentDisplayType === 1) {
        await this.APP_CU4002();
      } else if (this.$store.state.currentDisplayType === 2) {
        await this.APP_CU4004();
      }
      this.loading = false;
    },
  },
};
